/* ============================================
   LORDH Size Advisor - Client-side Logic
   ============================================ */
function gaEvent(eventName, params = {}) {
  if (typeof gtag !== 'function') return;
  gtag('event', eventName, params);
}

(function () {
  'use strict';

  /* --- State --- */
  const state = {
    step: 0,
    mode: 'brand',
    brand: null,
    region: 'eu',
    size: null,
    width: null, // 'narrow' | 'medium' | 'wide'
    result: null
  };

  /* --- Data (injected by Liquid into #sa-data) --- */
  let DATA = { brands: [], lordh: [] };

  /* --- DOM cache --- */
  let $overlay, $steps, $btnPrev, $btnNext, $footer;

  /* ========================================= */
  /*  INIT                                     */
  /* ========================================= */
  function init() {
    const dataEl = document.getElementById('sa-data');
    if (dataEl) {
      try { DATA = JSON.parse(dataEl.textContent); } catch (e) { console.error('SA: bad data', e); }
    }

    $overlay = document.getElementById('sa-overlay');
    $steps = $overlay.querySelectorAll('.sa-step');
    $btnPrev = $overlay.querySelector('.sa-btn--prev');
    $btnNext = $overlay.querySelector('.sa-btn--next');
    $footer = $overlay.querySelector('.sa-footer');

    bindTrigger();
    bindClose();
    bindStep0();
    bindStep1();
    bindStep2();
    bindStep3();
    bindStep5();
    bindNav();

    goToStep(0);
  }

  /* ========================================= */
  /*  OPEN / CLOSE                             */
  /* ========================================= */
  function open() {
document.querySelector('gty-whatsapp-chat-button').style.display="none";
    resetState();
    goToStep(0);
    $overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // GA4 — utente apre il popup
    gaEvent('size_advisor_open');
  }

  function close() {
document.querySelector('gty-whatsapp-chat-button').style.display="block";

    $overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function resetState() {
    state.step = 0;
    state.mode = 'brand';
    state.brand = null;
    state.region = 'eu';
    state.size = null;
    state.width = null;
    state.manualCm = 26;
    state.result = null;
    // Reset UI selections
    $overlay.querySelectorAll('.is-selected').forEach(el => el.classList.remove('is-selected'));
    const searchInput = $overlay.querySelector('.sa-search input');
    if (searchInput) searchInput.value = '';
    // Reset region to EU
    $overlay.querySelectorAll('.sa-region-tab').forEach(tab => {
      tab.classList.toggle('is-active', tab.dataset.region === 'eu');
    });
    // Reset measurement step UI
    const slider = $overlay.querySelector('.sa-length-slider');
    const input  = $overlay.querySelector('.sa-length-input');
    const unitLbl = $overlay.querySelector('.sa-length-unit');
    $overlay.querySelectorAll('.sa-unit-btn').forEach(b => {
      b.classList.toggle('is-active', b.dataset.unit === 'cm');
    });
    if (slider) { slider.min = 20; slider.max = 33; slider.step = 0.1; slider.value = 26; }
    if (input)  { input.value = '26.0'; input.min = 20; input.max = 33; }
    if (unitLbl) unitLbl.textContent = 'cm';
  }

  function bindTrigger() {
    document.querySelectorAll('[data-sa-open]').forEach(btn => {
      btn.addEventListener('click', open);
    });
  }

  function bindClose() {
    $overlay.querySelector('.sa-close-btn').addEventListener('click', close);
    $overlay.addEventListener('click', function (e) {
      if (e.target === $overlay) close();
    });
  }

  /* ========================================= */
  /*  NAVIGATION                               */
  /* ========================================= */
  function goToStep(n) {
    state.step = n;
    $steps.forEach(function (el) {
      el.classList.toggle('is-active', +el.dataset.step === n);
    });
    updateNav();
    if (n === 2) renderSizes();
    if (n === 4) renderResult();
  }

  function updateNav() {
    const s = state.step;

    $footer.classList.toggle('sa-footer--hidden', s === 0);
    $footer.classList.toggle('sa-footer--single', s === 1);

    if (s === 0) return;

    if (s === 1) {
      $btnPrev.style.display = '';
      $btnPrev.textContent = 'Previous';
      $btnNext.style.display = '';
      $btnNext.textContent = 'Next';
      $btnNext.disabled = !state.brand;
      $btnNext.classList.remove('sa-btn--close');
      $btnNext.classList.add('sa-btn--next');
      $footer.classList.remove('sa-footer--single');
    } else if (s === 2) {
      $btnPrev.style.display = ''; $btnPrev.textContent = 'Previous';
      $btnNext.style.display = ''; $btnNext.textContent = 'Next';
      $btnNext.disabled = !state.size;
      $btnNext.classList.remove('sa-btn--close');
      $btnNext.classList.add('sa-btn--next');
    } else if (s === 5) {
      $btnPrev.style.display = ''; $btnPrev.textContent = 'Previous';
      $btnNext.style.display = ''; $btnNext.textContent = 'Next';
      $btnNext.disabled = false;
      $btnNext.classList.remove('sa-btn--close');
      $btnNext.classList.add('sa-btn--next');
    } else if (s === 3) {
      $btnPrev.style.display = ''; $btnPrev.textContent = 'Previous';
      $btnNext.style.display = ''; $btnNext.textContent = 'Next';
      $btnNext.disabled = !state.width;
      $btnNext.classList.remove('sa-btn--close');
      $btnNext.classList.add('sa-btn--next');
    } else if (s === 4) {
      $btnPrev.style.display = ''; $btnPrev.textContent = 'Edit Measurements';
      $btnNext.style.display = ''; $btnNext.textContent = 'Close';
      $btnNext.disabled = false;
      $btnNext.classList.remove('sa-btn--next');
      $btnNext.classList.add('sa-btn--close');
    }
  }

  function bindNav() {
    $btnNext.addEventListener('click', function () {
      if ($btnNext.disabled) return;
      if (state.step === 4) { close(); return; }
      if (state.step === 1) { goToStep(2); return; }
      if (state.step === 2) { goToStep(3); return; }
      if (state.step === 5) { goToStep(3); return; }
      if (state.step === 3) { goToStep(4); return; }
    });

    $btnPrev.addEventListener('click', function () {
      if (state.step === 4) { goToStep(0); return; }
      if (state.step === 1) { goToStep(0); return; }
      if (state.step === 5) { goToStep(0); return; }
      if (state.step === 2) { goToStep(1); return; }
      if (state.step === 3) { goToStep(state.mode === 'manual' ? 5 : 2); return; }
    });
  }

  function bindStep0() {
    $overlay.querySelectorAll('[data-sa-choice]').forEach(function (card) {
      card.addEventListener('click', function () {
        const choice = card.dataset.saChoice;

        // GA4 — utente sceglie il percorso
        gaEvent('size_advisor_path_selected', { path: choice });

        if (choice === 'brand') {
          goToStep(1);
        } else if (choice === 'measure') {
          state.mode = 'manual';
          state.brand = null;
          goToStep(5);
        }
      });
    });
  }

  /* ========================================= */
  /*  STEP 1 - Brand Selection                 */
  /* ========================================= */
  function bindStep1() {
    const cards = $overlay.querySelectorAll('.sa-brand-card');
    const searchInput = $overlay.querySelector('.sa-search input');
    const searchResults = $overlay.querySelector('.sa-search-results');
    const manualBtn = $overlay.querySelector('[data-sa-manual]');

    // Card click
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(c => c.classList.remove('is-selected'));
        card.classList.add('is-selected');
        state.mode = 'brand';
        state.brand = card.dataset.handle;
        state.size = null;
        updateNav();

        // GA4 — utente seleziona un brand dalla griglia
        gaEvent('size_advisor_brand_selected', { brand_name: card.dataset.name || state.brand });
      });
    });

    // Manual measurement button
    if (manualBtn) {
      manualBtn.addEventListener('click', function () {
        state.mode = 'manual';
        state.brand = null;
        cards.forEach(c => c.classList.remove('is-selected'));
        goToStep(5);
      });
    }

    // Search
    if (searchInput && searchResults) {
      searchInput.addEventListener('input', function () {
        const q = this.value.trim().toLowerCase();
        if (!q) {
          searchResults.classList.remove('is-open');
          cards.forEach(c => c.classList.remove('is-hidden'));
          return;
        }
        cards.forEach(function (card) {
          const name = (card.dataset.name || '').toLowerCase();
          card.classList.toggle('is-hidden', !name.includes(q));
        });
        const matches = DATA.brands.filter(b => b.name.toLowerCase().includes(q));
        searchResults.innerHTML = '';
        if (matches.length === 0) {
          searchResults.innerHTML = '<div class="sa-search-no-results">No brand found</div>';
        } else {
          matches.forEach(function (b) {
            const item = document.createElement('div');
            item.className = 'sa-search-result-item';
            item.textContent = b.name;
            item.addEventListener('click', function () {
              state.mode = 'brand';
              state.brand = b.handle;
              state.size = null;
              searchInput.value = b.name;
              searchResults.classList.remove('is-open');
              cards.forEach(function (c) {
                c.classList.remove('is-selected', 'is-hidden');
                if (c.dataset.handle === b.handle) c.classList.add('is-selected');
              });
              updateNav();

              // GA4 — utente seleziona un brand dalla ricerca
              gaEvent('size_advisor_brand_selected', { brand_name: b.name });
            });
            searchResults.appendChild(item);
          });
        }
        searchResults.classList.add('is-open');
      });

      if (searchInput && searchResults) {
  document.addEventListener('click', function (e) {
    if (searchInput && searchResults &&
        !searchInput.contains(e.target) && 
        !searchResults.contains(e.target)) {
      searchResults.classList.remove('is-open');
    }
  });
}
    }
  }

  /* ========================================= */
  /*  STEP 2 - Size Selection                  */
  /* ========================================= */
  function bindStep2() {
    $overlay.querySelectorAll('.sa-region-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        $overlay.querySelectorAll('.sa-region-tab').forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        state.region = tab.dataset.region;
        state.size = null;
        renderSizes();
        updateNav();
      });
    });
  }

  function renderSizes() {
    const brand = DATA.brands.find(b => b.handle === state.brand);
    if (!brand) return;

    const brandNameEl = $overlay.querySelector('.sa-brand-name');
    if (brandNameEl) brandNameEl.textContent = brand.name;

    const grid = $overlay.querySelector('.sa-sizes-grid');
    if (!grid) return;

    const sizes = brand.sizes[state.region];
    if (!sizes) { grid.innerHTML = ''; return; }

    const labels = Object.keys(sizes).sort(function (a, b) {
      return parseFloat(a) - parseFloat(b);
    });
    grid.innerHTML = '';

    labels.forEach(function (label) {
      const chip = document.createElement('button');
      chip.className = 'sa-size-chip';
      chip.textContent = label;
      if (state.size === label) chip.classList.add('is-selected');
      chip.addEventListener('click', function () {
        grid.querySelectorAll('.sa-size-chip').forEach(c => c.classList.remove('is-selected'));
        chip.classList.add('is-selected');
        state.size = label;
        updateNav();
      });
      grid.appendChild(chip);
    });
  }

  /* ========================================= */
  /*  STEP 3 - Foot Width                      */
  /* ========================================= */
  function bindStep3() {
    const options = $overlay.querySelectorAll('.sa-width-option');
    const desc = $overlay.querySelector('.sa-width-description');

    const descriptions = {
      narrow: 'Narrow feet tend to have extra space on the shoe sides.',
      medium: 'Most common foot width. Standard fit.',
      wide: 'Wide feet may feel tight on the sides in standard shoes.'
    };

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
        state.width = opt.dataset.width;
        if (desc) desc.textContent = descriptions[state.width] || '';
        updateNav();
      });
    });
  }

  function bindStep5() {
    const slider  = $overlay.querySelector('.sa-length-slider');
    const input   = $overlay.querySelector('.sa-length-input');
    const unitLbl = $overlay.querySelector('.sa-length-unit');
    const unitBtns = $overlay.querySelectorAll('.sa-unit-btn');
    if (!slider || !input) return;

    let currentUnit = 'cm';

    function fromDisplayToCm(val) {
      const v = parseFloat(val);
      if (isNaN(v)) return state.manualCm;
      return currentUnit === 'cm' ? v : v * 2.54;
    }
    function fromCmToDisplay(cm) {
      return currentUnit === 'cm' ? cm : cm / 2.54;
    }

    slider.addEventListener('input', function () {
      const v = parseFloat(this.value);
      input.value = v.toFixed(1);
      state.manualCm = fromDisplayToCm(v);
    });

    input.addEventListener('input', function () {
      const v = parseFloat(this.value);
      if (isNaN(v)) return;
      const min = parseFloat(slider.min), max = parseFloat(slider.max);
      const clamped = Math.max(min, Math.min(max, v));
      slider.value = clamped;
      state.manualCm = fromDisplayToCm(v);
    });

    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const newUnit = btn.dataset.unit;
        if (newUnit === currentUnit) return;
        unitBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        currentUnit = newUnit;

        if (newUnit === 'cm') {
          slider.min = 20;  slider.max = 33;   slider.step = 0.1;
          input.min  = 20;  input.max  = 33;
        } else {
          slider.min = 7.9; slider.max = 13;   slider.step = 0.1;
          input.min  = 7.9; input.max  = 13;
        }
        const newVal = fromCmToDisplay(state.manualCm);
        slider.value = newVal;
        input.value = newVal.toFixed(1);
        unitLbl.textContent = newUnit;
      });
    });
  }

  /* ========================================= */
  /*  STEP 4 - Result / Conversion             */
  /* ========================================= */
  function renderResult() {
    let cmValue;
    if (state.mode === 'manual') {
      cmValue = state.manualCm;
    } else {
      const brand = DATA.brands.find(b => b.handle === state.brand);
      if (!brand) return;
      const sizes = brand.sizes[state.region];
      if (!sizes || !state.size) return;
      cmValue = sizes[state.size];
    }
    if (cmValue == null) return;

    // Find matching LORDH size
    let matchIndex = -1;
    for (let i = 0; i < DATA.lordh.length; i++) {
      const row = DATA.lordh[i];
      if (cmValue >= row.cm_min && cmValue <= row.cm_max) {
        matchIndex = i;
        break;
      }
    }

    // Fallback: closest match
    if (matchIndex === -1) {
      let minDiff = Infinity;
      DATA.lordh.forEach(function (row, i) {
        const mid = (row.cm_min + row.cm_max) / 2;
        const diff = Math.abs(cmValue - mid);
        if (diff < minDiff) { minDiff = diff; matchIndex = i; }
      });
    }

    // Adjust for narrow foot
    let recommendedIndex = matchIndex;
    if (state.width === 'narrow' && matchIndex > 0) {
      recommendedIndex = matchIndex - 1;
    }

    const recommended = DATA.lordh[recommendedIndex];
    const altIndex = recommendedIndex + 1 < DATA.lordh.length ? recommendedIndex + 1 : recommendedIndex - 1;
    const alt = DATA.lordh[altIndex] || null;

    state.result = { recommended, alt, recommendedIndex, altIndex };

    // GA4 — risultato mostrato all'utente
    gaEvent('size_advisor_result_shown', {
      recommended_size_eu: recommended.eu,
      foot_width:          state.width,
      mode:                state.mode,
      brand_name:          state.mode === 'brand' ? state.brand : null
    });

    // Render size cards
    const sizesContainer = $overlay.querySelector('.sa-result-sizes');
    if (sizesContainer) {
      sizesContainer.innerHTML = '<div class="sa-result-size-card is-best">' + recommended.eu + '</div>';
    }

    // Render conversion table
    const tableContainer = $overlay.querySelector('.sa-conversion-table');
    if (tableContainer && recommended) {
      tableContainer.innerHTML = ''
        + '<div class="sa-conv-cell is-header">EU</div>'
        + '<div class="sa-conv-cell is-header">UK</div>'
        + '<div class="sa-conv-cell is-header">US</div>'
        + '<div class="sa-conv-cell is-header">CM</div>'
        + '<div class="sa-conv-cell is-eu">' + recommended.eu + '</div>'
        + '<div class="sa-conv-cell">' + recommended.uk + '</div>'
        + '<div class="sa-conv-cell">' + recommended.us + '</div>'
        + '<div class="sa-conv-cell">' + ((recommended.cm_min + recommended.cm_max) / 2).toFixed(1) + '</div>';
    }
  }

  /* ========================================= */
  /*  BOOT                                     */
  /* ========================================= */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();